import { TypeRowCell, TableRow } from './styled';
import { Text, useTheme } from '@simplywallst/ui-core';

type HoldingTypeRow = {
  type: 'declared' | 'estimated';
  total: string;
};

export const HoldingTypeRow = ({ type, total }: HoldingTypeRow) => {
  const theme = useTheme();
  return (
    <TableRow tabIndex={0}>
      <TypeRowCell
        color={
          type === 'declared'
            ? theme.color.chart02RGBA(0.1)
            : theme.color.chart03RGBA(0.1)
        }
      >
        <Text typography="xSmall">
          {type === 'declared' ? 'Declared' : 'Estimated'} Payments
        </Text>
      </TypeRowCell>
      <TypeRowCell
        color={
          type === 'declared'
            ? theme.color.chart02RGBA(0.1)
            : theme.color.chart03RGBA(0.1)
        }
      >
        <Text typography="xSmall">{total}</Text>
      </TypeRowCell>
    </TableRow>
  );
};
